import { Icon } from "@iconify/react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useEffect, useState, useMemo, useContext, useRef } from "react";
import {
  notify,
  highlightSearchText,
  highlightEntities,
  generateDocContent,
  highlightLastSearchTerm,
} from "../../utils/utils";
import { MyContext } from "../../MyContext/MyProvider";
import { toast } from "react-toastify";

var ineer = "";
const baseUrl = "https://redact.octalooptechnologies.com/";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const Pattern = ({ selectedFile, reductionType, id }) => {
  const idString = String(id);
  const {
    selectedEntities,
    findingsWithHighlight,
    searchText,
    setSearchText,
    saveTerms,
    setSaveTerms,
    savePara,
    setSavePara,
  } = useContext(MyContext);

  const [selectedText, setSelectedText] = useState("");

  const contentRef = useRef(null);

  const searchAndSaveTerm = (text, term) => {
    // Escape special characters in the term
    console.log("term", term);
    console.log("text", text);
    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    // Initialize the object if it doesn't already exist
    setSaveTerms((prevSaveTerms) => {
      if (!prevSaveTerms.hasOwnProperty(term)) {
        const newSaveTerms = { ...prevSaveTerms, [term]: [] }; // Initialize an empty array for the term

        // Strip HTML tags to find clean text for matching
        const stripTags = (html) => html.replace(/<[^>]+>/g, "");
        const originalTextStripped = stripTags(text);

        // Regex to find all occurrences of the term as a standalone word
        const termRegex = new RegExp(`\\b${escapedTerm}\\b`, "gi");
        let match;

        while ((match = termRegex.exec(originalTextStripped)) !== null) {
          // Add the index of each match to the array for the term
          newSaveTerms[term].push(match.index);
        }

        console.log(`Found term "${term}" ${newSaveTerms[term].length} times.`);
        return newSaveTerms; // Return the updated state
      } else {
        console.log(`Term "${term}" already exists in saveTerms.`);
        return prevSaveTerms; // Return the previous state as it is
      }
    });
    console.log(saveTerms);
    return saveTerms; // This will return the updated state
  };

  const fileFindings = useMemo(() => {
    return findingsWithHighlight.filter(
      (finding) => finding.file_id === selectedFile.file_id
    );
  }, [findingsWithHighlight, selectedFile.file_id]);

  function toggleHighlight(span) {
    console.log("span", span);
    console.log("saveTerms:", saveTerms);

    // Get the index from the span's data attribute and convert it to an integer
    const spanIndex = parseInt(span.getAttribute("data-index"), 10);
    console.log("Span Index:", spanIndex);

    if (span.classList.contains("highlight-search")) {
      // Get the text inside the span
      let spanText = span.innerHTML.trim();
      console.log("Original Span Text:", spanText);

      // Strip HTML tags from the spanText for comparison
      const cleanSpanText = spanText.replace(/<[^>]*>/g, "").trim();
      console.log("Clean Span Text:", cleanSpanText);

      // Remove the highlight-search class and add unhighlight
      span.classList.remove("highlight-search");
      span.classList.add("unhighlight");

      // Iterate over the keys of the saveTerms object
      Object.keys(saveTerms).forEach((term) => {
        // Check if the term matches the cleanSpanText
        if (term.toLowerCase() === cleanSpanText.toLowerCase()) {
          console.log("Matching Term:", term);
          const termArray = saveTerms[term];

          // Set the value at the spanIndex to -1 if it exists in the array
          if (termArray[spanIndex] !== undefined) {
            termArray[spanIndex] = -1;
            console.log(`Set saveTerms['${term}'][${spanIndex}] to -1.`);
          } else {
            console.error("Index out of bounds for the term array.");
          }
        }
      });

      // Update the saveTerms state
      setSaveTerms({ ...saveTerms }); // This assumes you have a setSaveTerms function from your context
    }
  }

  function toggleHighlight2(span) {
    if (span.classList.contains("highlight-search")) {
      // Retrieve searchText from context

      // Get the text inside the span
      const spanText = span.innerHTML.trim(); // Ensure any extra whitespace is removed

      // Strip HTML tags from spanText for comparison
      const cleanSpanText = spanText.replace(/<[^>]+>/g, "").trim();

      // Log cleanSpanText for debugging
      console.log("cleanSpanText:", cleanSpanText);

      // Remove the highlight-search class and add unhighlight
      span.classList.remove("highlight-search");
      span.classList.add("unhighlight");

      // Update the searchText array
      const updatedSearchText = savePara
        .map((text) => {
          // Check if text contains cleanSpanText with improved matching
          if (text.includes(cleanSpanText)) {
            // Remove the cleanSpanText from the text
            const updatedText = text.replace(cleanSpanText, "").trim();
            console.log("updatedText:", updatedText);
            return updatedText.length > 0 ? updatedText : null; // Avoid empty strings
          }
          return text;
        })
        .filter((text) => text !== null); // Filter out null values

      // Set the updated searchText in context
      setSavePara(updatedSearchText);

      // Log the updated searchText for debugging
      console.log("Updated searchText:", updatedSearchText);
    } else {
      // Toggle highlight class
      span.classList.remove("unhighlight");
      span.classList.add("highlight-search");

      // Get the text inside the span
      const spanText = span.innerHTML.trim(); // Ensure any extra whitespace is removed

      // Strip HTML tags from spanText for comparison
      const cleanSpanText = spanText.replace(/<[^>]+>/g, "").trim();

      // Log cleanSpanText for debugging
      console.log("cleanSpanText:", cleanSpanText);

      // Update the searchText array
      const updatedSearchText = [...savePara, cleanSpanText]; // Add cleanSpanText back to searchText

      // Set the updated searchText in context
      setSavePara(updatedSearchText);

      // Log the updated searchText for debugging
      console.log("Updated searchText:", updatedSearchText);
    }
  }

  const addSpansToSaveTerms = (
    text,
    saveTerms,
    reductionType = "highlight"
  ) => {
    console.log("Original Text:", text);
    console.log("Save Terms:", saveTerms);

    window.toggleHighlight2 = toggleHighlight2;

    // Function to remove 'highlight' and 'no-highlight' spans from within a specific term
    const removeHighlightClassesFromText = (html) => {
      return html
        .replace(/<span\s+class="(highlight|no-highlight)"[^>]*>/gi, "")
        .replace(/<\/span>/gi, "");
    };

    // Strip HTML tags to get clean text for matching
    const stripTags = (html) => html.replace(/<[^>]+>/g, "");

    // Loop through each term in saveTerms
    for (let term of saveTerms) {
      // Create a regex to find the term in the stripped text
      const cleanTerm = stripTags(term).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const termRegex = new RegExp(cleanTerm, "gi");

      // Strip HTML tags from the original text for regex matching
      const originalTextStripped = stripTags(text);

      // Find all matches of the term in the stripped text
      let match;
      while ((match = termRegex.exec(originalTextStripped)) !== null) {
        const matchedText = match[0];
        const matchStart = match.index;

        // Calculate the match end position
        const matchEnd = matchStart + matchedText.length;

        // Find the corresponding position in the original HTML text
        let charIndex = 0;
        let htmlIndex = 0;
        while (charIndex < matchStart && htmlIndex < text.length) {
          if (text[htmlIndex] === "<") {
            // Skip over HTML tags
            while (htmlIndex < text.length && text[htmlIndex] !== ">") {
              htmlIndex++;
            }
          } else {
            charIndex++;
          }
          htmlIndex++;
        }

        const htmlMatchStart = htmlIndex;

        // Now find the match end in the HTML
        while (charIndex < matchEnd && htmlIndex < text.length) {
          if (text[htmlIndex] === "<") {
            // Skip over HTML tags
            while (htmlIndex < text.length && text[htmlIndex] !== ">") {
              htmlIndex++;
            }
          } else {
            charIndex++;
          }
          htmlIndex++;
        }

        const htmlMatchEnd = htmlIndex;

        // Extract the HTML match and wrap it with the highlight-search span
        const htmlMatch = text.slice(htmlMatchStart, htmlMatchEnd);
        const cleanedHtmlMatch = removeHighlightClassesFromText(htmlMatch);
        const highlightedMatch = `<span class="${
          reductionType === "mask" ? "mask" : "highlight-search"
        }" onClick="toggleHighlight2(this)">${cleanedHtmlMatch}</span>`;

        // Replace the original HTML text with the highlighted match
        text =
          text.slice(0, htmlMatchStart) +
          highlightedMatch +
          text.slice(htmlMatchEnd);

        // Adjust regex lastIndex to continue searching after the replaced term
        termRegex.lastIndex = matchEnd;
      }
    }

    console.log("Final Highlighted Text:", text);
    return text;
  };

  const addSpansForTermsWithIndices = (
    highlightedText,
    saveTerms,
    reductionType = "highlight"
  ) => {
    window.toggleHighlight = toggleHighlight;
    console.log(saveTerms);

    for (const [term, indices] of Object.entries(saveTerms)) {
      if (!indices || indices.length === 0) continue;

      let matchCounter = 0;
      let match;
      let resultText = "";

      // Create a regex to find all instances of the current term
      const termRegex = new RegExp(
        `\\b${term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`,
        "gi"
      );

      let cursor = 0;
      while ((match = termRegex.exec(highlightedText)) !== null) {
        const start = match.index;
        const end = start + match[0].length;

        // Append the text before the current match
        resultText += highlightedText.slice(cursor, start);

        // Check if the current index is not -1
        if (indices[matchCounter] !== -1) {
          resultText += `<span class="${
            reductionType === "mask" ? "mask" : "highlight-search"
          }" data-index="${matchCounter}" onClick="toggleHighlight(this)">`;
          resultText += highlightedText.slice(start, end);
          resultText += "</span>";
        } else {
          resultText += highlightedText.slice(start, end);
        }

        cursor = end;
        matchCounter++;
      }

      // Append any remaining text after the last match
      resultText += highlightedText.slice(cursor);

      // Update the text to the new version with the added spans
      highlightedText = resultText;
    }

    return highlightedText;
  };

  const combinedHighlighting = useMemo(() => {
    let highlightedText = highlightEntities(
      selectedFile.anonymized_text,
      fileFindings,
      selectedEntities,
      reductionType
    );
    console.log("searh", searchText);
    console.log("searh", savePara);

    if (
      (searchText.length > 0 &&
        searchText.some((text) => text.trim() !== "")) ||
      (savePara.length > 0 && savePara.some((text) => text.trim() !== ""))
    ) {
      const lastterm = searchText[searchText.length - 1];
      console.log(saveTerms);
      console.log(savePara);
      console.log("send", highlightedText);
      if (reductionType == "highlight") {
        if (lastterm) {
          searchAndSaveTerm(highlightedText, lastterm);
        }
        highlightedText = addSpansToSaveTerms(
          highlightedText,
          savePara,
          reductionType
        );
        console.log(highlightedText);
        console.log(saveTerms);
        highlightedText = addSpansForTermsWithIndices(
          highlightedText,
          saveTerms,
          reductionType
        );
        console.log(highlightedText);
      }
      if (reductionType === "mask") {
        // Replace the class "highlight" or "highlight-search" with "mask"
        highlightedText = contentRef.current.innerHTML
          .replace(/highlight-search/g, "mask")
          .replace(/highlight/g, "mask");
        console.log("hello", contentRef.current.innerHTML);
      }
      console.log("text", highlightedText);
      console.log("term", saveTerms);
    }

    return highlightedText;
  }, [
    selectedFile,
    selectedEntities,
    searchText,
    reductionType,
    saveTerms,
    savePara,
    findingsWithHighlight,
  ]);
  const escapeHtml = (text) => {
    return text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  };
  useEffect(() => {
    ineer = contentRef.current.innerHTML;
    console.log(ineer);
    if (reductionType === "replace") {
      console.log("hello");
      const escapedHighlighting = escapeHtml(combinedHighlighting);
      contentRef.current.innerHTML = escapedHighlighting;
    } else {
      console.log("hello", combinedHighlighting);

      contentRef.current.innerHTML = combinedHighlighting;
    }
    const handleMouseUp = () => {
      let text = "";
      if (window.getSelection) {
        text = window.getSelection().toString();
      } else if (document.getSelection) {
        text = document.getSelection().toString();
      } else if (document.selection) {
        text = document.selection.createRange().text;
      }
      setSelectedText(text);
    };
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [combinedHighlighting]);

  const handleDownloadClick = async () => {
    let highlightedText = highlightEntities(
      selectedFile.anonymized_text,
      fileFindings,
      selectedEntities,
      reductionType
    );
  
    const updatedHtml = contentRef.current.innerHTML; // Capture the current HTML content
    console.log(savePara, selectedFile.anonymized_text);
  
    // Generate JSON content
    const jsonContent = generateJsonContent(highlightedText);
    downloadPdf(updatedHtml); // Pass updated HTML to downloadPdf
    
    // Instead of returning, now you send the JSON to your API
    try {
      const response = await fetch(`${baseUrl}/upload-jsonl`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Specify JSON content type
        },
        body: JSON.stringify(jsonContent), // Send jsonContent as a JSON string
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
  
      const data = await response.json();
      console.log('Upload successful:', data);
    } catch (error) {
      console.error('Error uploading JSON:', error);
    }
  
    // If you want to proceed with the PDF download after the upload
  };
  

  const removeHtmlTags = (text) => {
    return text
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  // Function to find and return JSON format without newlines
  const generateJsonContent = (text) => {
    const jsonObjects = []; // JSON objects array

    // Remove HTML tags from the input text
    const cleanAnonymizedText = removeHtmlTags(text);

    savePara.forEach((paragraph) => {
      // Clean up extra spaces for matching
      const cleanParagraph = paragraph.replace(/\s+/g, " ").trim();
      const start = cleanAnonymizedText.indexOf(cleanParagraph); // Find start index

      if (start !== -1) {
        const end = start + cleanParagraph.length; // Calculate end index
        const jsonObject = {
          'text': cleanAnonymizedText,
          'entities': [[start, end, "Manual Selected"]],
        };
        jsonObjects.push(jsonObject);
      }
    });  

    // Convert to JSON string without newlines
    return jsonObjects
  };


  const downloadPdf = (htmlContent) => {
    const docDefinition = {
      content: [
        {
          text: "Anonymized Text:",
          style: "header",
        },
        {
          text: generateDocContent(htmlContent, reductionType),
          style: "normal",
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
        },
        normal: {
          fontSize: 12,
        },
      },
    };

    pdfMake.createPdf(docDefinition).download(); // Generate and download the PDF
  };

  return (
    <>
      <div className="d-flex flex-column comp container mt-5">
        <div className="file-name">
          <h4>{selectedFile.file_name}</h4>
        </div>
        <div className="comp-inner d-flex gap-5 mt-3">
          <div className="column left flex-fill">
            {/* Original Text */}
            <h4>Original Text</h4>
            <p className="blockquote">{selectedFile.original_text}</p>
          </div>

          <div className="column right flex-fill">
            {/* Anonymized Text with Entity Highlighting */}
            <h4>Anonymized Text</h4>
            <div className="blockquote">
              <div id={idString} ref={contentRef}>
                Processed text should be replaced here
              </div>
            </div>
          </div>
        </div>
        <div className="keywords-div h-center v-center gap-3 w-100 mt-4">
          <label
            className="large keyword-selected fw-medium text-white v-center h-center cursor-pointer d-flex gap-2 px-3"
            onClick={handleDownloadClick}
          >
            <Icon
              icon="ph:download-fill"
              width={25}
              height={30}
              className="file-icon"
            />
            Download
          </label>
          {/* <label
            className="large keyword-selected fw-medium text-white v-center h-center cursor-pointer d-flex gap-2 px-3"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={() => {
              if (selectedText.trim()) {
                console.log(selectedText.length);
                if (selectedText.length >= 5) {
                  setSavePara([...savePara, selectedText.trim()]);
                } else {
                  // Show a toast notification if the input is invalid
                  toast.error(
                    "Please select at least 5 alphabetic characters."
                  );
                }
              } else {
                notify("No text is selected", "error");
              }
            }}
          >
            Search selected text
          </label> */}
        </div>
      </div>
    </>
  );
};

export default Pattern;

